import { useFontStyle } from "~/hook/useFontStyle";
import { cn } from "~/lib/utils";

function NoHasMoreText({ text, className }: { text: string; className?: string }) {
  const { medium } = useFontStyle();
  return (
    <div className="w-full flex justify-center items-center pt-5">
      <p className={cn("text-textSecondaryColor body_text_m", medium, className)}>{text}</p>
    </div>
  );
}

export default NoHasMoreText;
